import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

export type AccessReason =
  | 'forbidden'
  | 'unauthenticated'
  | 'expired'
  | 'notfound'
  | 'servererror'
  | 'unknown';

export type ActionType = 'home' | 'login' | 'reload' | 'back';

export type IconType = 'lock' | 'shield' | 'search' | 'server' | 'help';

export interface ReasonConfig {
  title: string;
  subtitle: string;
  primaryText: string;
  action: ActionType;
  secondaryText?: string;
  secondaryAction?: ActionType;
  badgeClass: string;
  iconType: IconType;
}

const ACCESS_CONFIG: Record<AccessReason, ReasonConfig> = {
  unauthenticated: {
    title: 'Perlu Login',
    subtitle: 'Silakan login terlebih dahulu untuk melanjutkan.',
    primaryText: 'Login',
    action: 'login',
    badgeClass: 'bg-amber-50 text-amber-600',
    iconType: 'lock'
  },
  expired: {
    title: 'Sesi Berakhir',
    subtitle: 'Sesi Anda sudah berakhir. Silakan login ulang.',
    primaryText: 'Login Ulang',
    action: 'login',
    badgeClass: 'bg-amber-50 text-amber-600',
    iconType: 'lock'
  },
  forbidden: {
    title: 'Akses Ditolak',
    subtitle: 'Akun Anda tidak memiliki izin untuk membuka halaman ini.',
    primaryText: 'Ke Beranda',
    action: 'home',
    badgeClass: 'bg-red-50 text-red-600',
    iconType: 'shield'
  },
  notfound: {
    title: 'Halaman Tidak Ditemukan',
    subtitle: 'Link yang Anda buka tidak tersedia atau alamatnya tidak valid.',
    primaryText: 'Ke Beranda',
    action: 'home',
    badgeClass: 'bg-blue-50 text-blue-600',
    iconType: 'search'
  },
  servererror: {
    title: 'Terjadi Kesalahan Sistem',
    subtitle: 'Sistem sedang mengalami gangguan. Silakan coba lagi nanti.',
    primaryText: 'Muat Ulang',
    action: 'reload',
    secondaryText: 'Ke Beranda',
    secondaryAction: 'home',
    badgeClass: 'bg-rose-50 text-rose-600',
    iconType: 'server'
  },
  unknown: {
    title: 'Tidak Bisa Dibuka',
    subtitle: 'Halaman ini tidak bisa diakses saat ini.',
    primaryText: 'Ke Beranda',
    action: 'home',
    badgeClass: 'bg-gray-50 text-gray-600',
    iconType: 'help'
  }
};

@Component({
  selector: 'app-access-message',
  templateUrl: './access-message.component.html',
  styleUrls: ['./access-message.component.scss']
})
export class AccessMessageComponent implements OnInit {

  reason: AccessReason = 'unknown';

  title = '';
  subtitle = '';
  primaryText = '';
  action: ActionType = 'home';
  secondaryText?: string;
  secondaryAction?: ActionType;
  badgeClass = 'bg-gray-50 text-gray-600';
  iconType: IconType = 'help';

  detail = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParamMap;
    const r = (queryParams.get('reason') || 'unknown') as AccessReason;

    this.reason = Object.prototype.hasOwnProperty.call(ACCESS_CONFIG, r)
      ? r
      : 'unknown';

    const config = ACCESS_CONFIG[this.reason];

    this.title = queryParams.get('title') || config.title;
    this.subtitle = queryParams.get('message') || queryParams.get('subtitle') || config.subtitle;
    this.primaryText = queryParams.get('primaryText') || config.primaryText;
    this.action = (queryParams.get('action') as ActionType) || config.action;
    this.secondaryText = queryParams.get('secondaryText') || config.secondaryText;
    this.secondaryAction = (queryParams.get('secondaryAction') as ActionType) || config.secondaryAction;
    this.badgeClass = config.badgeClass;
    this.iconType = config.iconType;

    const from = queryParams.get('from');
    const customDetail = queryParams.get('detail');
    if (customDetail) {
      this.detail = customDetail;
    } else if (from) {
      this.detail = `Dari: ${from}`;
    }
  }

  goAction(action?: ActionType): void {
    const targetAction = action || this.action;

    if (targetAction === 'login') {
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    if (targetAction === 'back') {
      window.history.back();
      return;
    }

    if (targetAction === 'reload') {
      const from = this.route.snapshot.queryParamMap.get('from');
      if (from) {
        window.location.replace(from);
      } else {
        this.router.navigateByUrl('/', { replaceUrl: true });
      }
      return;
    }

    this.router.navigateByUrl('/', { replaceUrl: true });
  }
}
